import { FilledInput, InputAdornment } from "@mui/material";
import SearchIcon from "../../assets/images/Search.svg";

import "./Search.scss";

export default function Search(props: { onChange: CallableFunction }) {
    return (<FilledInput id="filled-adornment" disableUnderline={true} type={"text"} placeholder={"Search"}
        classes={{ root: "search-container", input: "input" }} onChange={(e) => { props.onChange(e.target.value) }}
        startAdornment={
            <InputAdornment classes={{ root: "img-container" }} position="end">
                <img className="img" src={SearchIcon} alt={"Search"} />
            </InputAdornment>
        }
    />)
}